<!-- <template>
  <div>
    <b-button
      class="buttonii"
      @click="showModal"
    >
      Add Bank Holidays
    </b-button>

    <b-modal
      ref="modal"
      v-model="modalShow"
      title="Add Bank Holidays"
      @hide="onModalHide"
    >
      <b-form-group
        label="Select Country State name"
        label-for="countryState"
      >
        <vue-select
          id="Name"
          v-model="form.countryStateId"
          :options="getCantons"
          :reduce="(e) => e.countryStateId"
          label="name"
        />
      </b-form-group>
      <div
        v-for="(item, index) in form.bankHolidayDtos"
        :key="index"
      >

        <b-form-group
          label="Select bank holiday name"
          label-for="countryState"
        >
          <b-form-input
            id="CountryState"
            v-model="item.bankHolidayName"
          />
        </b-form-group>
        <b-form-group
          label="Select days "
          label-for="countryState"
        >
          <b-form-input
            id="CountryState"
            v-model.number="item.noOfDays"
          />
        </b-form-group>
        <b-form-group
          id="input-group-1"
          :label="$t('EmployeeStartingDay')"
          label-for="input-1"
        >
          <date-picker
            v-model="item.bankHolidayDate"
            style="width: 100%"
            value-type="format"
            placeholder="Select Date"
            :format="'YYYY-MM-DD'"
          />
        </b-form-group>
      </div>


      <template #modal-footer>
        <div class="modal-footerr">
          <b-button
            type="button"
            variant="none"
            class="buttonSubmit"
            @click="onSubmitAddUser"
          >
            Save
          </b-button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            @click="onCancel"
          >
            Close
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template> -->

<template>
  <div>
    <b-modal
      id="add-bank-holidays"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('AddBankHolidays')"
      size="l"
      hide-footer
      @close="onCancel"
    >
      <b-form-group
        :label="$t('SelectCountryStateName')"
        label-for="countryState"
      >
        <vue-select
          id="Name"
          v-model="form.countryStateId"
          :options="getCantons"
          :reduce="(e) => e.countryStateId"
          label="name"
        />
      </b-form-group>
      <div
        v-for="(item, index) in form.bankHolidayDtos"
        :key="index"
      >

        <b-form-group
          :label="$t('HolidayName')"
          label-for="countryState"
        >
          <b-form-input
            id="CountryState"
            v-model="item.bankHolidayName"
          />
        </b-form-group>
        <b-form-group
          :label="$t('SelectDays')"
          label-for="countryState"
        >
          <b-form-input
            id="CountryState"
            v-model.number="item.noOfDays"
          />
        </b-form-group>
        <b-form-group
          id="input-group-1"
          :label="$t('EmployeeStartingDay')"
          label-for="input-1"
        >
          <date-picker
            v-model="item.bankHolidayDate"
            style="width: 100%"
            value-type="format"
            placeholder="Date"
            :format="'YYYY-MM-DD'"
          />
        </b-form-group>
      </div>
      <div style="margin-top: 10px;">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          @click="onSubmitAddUser"
        >
          {{ $t("Submit") }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px"
          @click="onCancel"
        >
          {{ $t("Cancel") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';




export default {
  components: {
    // flatPickr,
    DatePicker,
  },
  data() {
    return {
      modalShow: false,
      inputValue: '',
      form: {
        countryStateId: '',
        bankHolidayDtos: [],
      },
    };
  },
  computed: {
    ...mapGetters([
      'getCantons',
    ]),
  },
  mounted() {
    this.form.bankHolidayDtos.push({
      bankHolidayName: '',
      noOfDays: 0,
      bankHolidayDate: Date,
    })
    // this.loadCountryStates()
  },
  methods: {
    ...mapActions(['bankHolidays', 'loadCountryStates']),
    showModal() {
      this.modalShow = true;
    },
    hideModal() {
      this.modalShow = false;
    },
    saveData() {
    },
    onModalHide() {
    },
    async onSubmitAddUser() {
      // console.log(this.form)
      this.$emit('pushBankHoliday', this.form);
      this.$refs.modal.hide();
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.onReset();
    },
    onCancel() {
      this.$refs.modal.hide();
      setTimeout(() => {
        this.$v.$reset();
      }, 0);
      this.$nextTick(() => {
        this.$v.$reset();
      });
      this.onReset();
    },
    onReset() {
      // Reset our form values
      this.form.bankHolidayDtos.bankHolidayName = '';
      this.form.bankHolidayDtos.countryStateId = '';
      this.form.bankHolidayDtos.bankHolidayDate = '';
      this.form.bankHolidayDtos.noOfDays = '';


      // Trick to reset/clear native browser form validation state
    },
  },
};
</script>

<style scoped>
.buttonii{
    background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box;
    font-weight: 500;
    color: #FBFAF7;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    height: 42px;
    margin-top: 25px;
    margin-right: 20px;
    width: 100%;
}

.modal-footerr{
  display: inline-block;
}

#modal-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* .buttonSubmit{
  position: absolute;
  left: 0;
  transform: translateY(-10%);
  transform: translateX(0%);
  margin-left: 20px;
}

.buttonCancel{
  transform: translateY(-10%);
  transform: translateX(-30);
} */
</style>
